export const isAlphanumeric = (value) => {
  return (value.match(/^[-_ a-zA-Z0-9]+$/) || []).length
}

/**
 * Validates username length (no format restrictions to support all existing usernames)
 * @param {string} username - The username to validate
 * @returns {boolean} - True if username is valid length
 */
export const isValidUsername = (username) => {
  if (!username) return false;
  // Only validate length: min 5 (to match register), max 255 (to support admin-created usernames)
  // No format validation - support all characters to match existing usernames in database
  return username.length >= 5 && username.length <= 255;
}